var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#C4D4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05142 6.50684C7.65049 6.50684 6.50391 7.65339 6.50391 9.05435V16.9597C6.50391 18.3607 7.65046 19.5068 9.05142 19.5068H16.9568C18.3578 19.5068 19.5039 18.3607 19.5039 16.9597V9.05435C19.5039 7.65342 18.3578 6.50684 16.9568 6.50684H9.05142ZM9.69216 8.6521C10.3639 8.6521 10.7776 9.09307 10.7904 9.67272C10.7904 10.2396 10.3638 10.6929 9.67917 10.6929H9.66656C9.00763 10.6929 8.58173 10.2396 8.58173 9.67272C8.58173 9.09308 9.02052 8.6521 9.69215 8.6521H9.69216ZM15.4807 11.3613C16.7726 11.3613 17.741 12.2057 17.741 14.0201V17.4075H15.7777V14.2472C15.7777 13.4531 15.4936 12.9113 14.7831 12.9113C14.2407 12.9113 13.9174 13.2765 13.7755 13.6293C13.7236 13.7555 13.7109 13.9317 13.7109 14.1083V17.4075H11.7476C11.7476 17.4075 11.7734 12.0542 11.7476 11.4998H13.7113V12.3364C13.9722 11.9339 14.4389 11.3613 15.4807 11.3613V11.3613ZM8.69754 11.5003H10.6608V17.4075H8.69754V11.5003Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4823eda7cebf0acaa2465be65fbac4a7.svg";
export { ForwardRef as ReactComponent };